




import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class Headline extends Vue {
  @Prop()
  private txt!: string
}
